import { useNavigate } from 'react-router-dom';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { UnidadForm } from '@/features/unidades/unidad-form';
import { useCreateUnidad } from '@/features/unidades/api';
import { useCondoContext } from '@/features/auth/use-condo-context';

export function NuevaUnidadRoute() {
  const nav = useNavigate();
  const { condoId: tenantId } = useCondoContext();
  const mutation = useCreateUnidad(tenantId);

  return (
    <PageContainer width="narrow">
      <PageHeader eyebrow="Nueva" title="Nueva unidad" ruleSpacing="mb-8" />
      <UnidadForm
        submitLabel="Crear unidad"
        submitting={mutation.isPending}
        onSubmit={(values) => {
          mutation.mutate(values, {
            onSuccess: (created) => nav(`/app/condominios/${tenantId}/unidades/${created.id}`),
          });
        }}
      />
    </PageContainer>
  );
}
